import React, { useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useAppApi } from "@/App";
import { useRequest } from "@components/AppHook";
import { ExportButton } from "@components/Common/Button";
import { DevForm, FormFieldGroup } from "@components/Forms/Fields";
import { DevModal } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { parseQS, url_reverse } from "@components/Utils";

export default function MarketForeignInvoiceScreen() {
    return (
        <DefaultLayout>
            <List />
        </DefaultLayout>
    );
}

function List() {
    const { t } = useTranslation();
    const { apiData, apiUrl, setApiReget } = useAppApi(url_reverse("api:market:foreign_invoice:list"));
    const [changeEmail, setChangeEmail] = useState({});
    const { api_post } = useRequest();

    if (!apiData) return;

    const closeModal = () => {
        setChangeEmail({});
    };

    const doChangeEmail = (ev) => {
        api_post(ev, apiUrl, {
            params: { action: "change_email", user_id: changeEmail.user_id, email: changeEmail.email },
            then: (resp) => {
                if (resp.status === "ok") {
                    setApiReget(true);
                    closeModal();
                }
            },
        });
    };

    const headerTools = (
        <>
            <Button href="#" variant="dark" size="sm" onClick={() => setChangeEmail({ show: true })}>
                {t("Сменить почту для чеков")}
            </Button>{" "}
            <ExportButton size="sm" prms={parseQS()} />;
        </>
    );

    return (
        <ListingCard header={t("Пополнение Steam")} headerTools={headerTools}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Sezam ID</th>
                        <th>Email</th>
                        <th>{t("Состояние")}</th>
                        <th>{t("Тип платежа")}</th>
                        <th>{t("Транзакция")}</th>
                        <th>{t("Дата создания")}</th>
                        <th>{t("Дата оплаты")}</th>
                        <th>{t("Сумма оплаты")}</th>
                        <th>inv_extra</th>
                        <th>{t("Ошибка")}</th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o) => {
                        return (
                            <tr key={`object_list${o.id}`}>
                                <td>{o.id}</td>
                                <td>{o.user_id}</td>
                                <td>{o.receipt_email}</td>
                                <td>{o.state}</td>
                                <td>{o.payment_type}</td>
                                <td>{o.payment_id}</td>
                                <td>{o.date_ordered}</td>
                                <td>{o.date_payed}</td>
                                <td>{o.payment_sum}</td>
                                <td>{JSON.stringify(o.inv_extra, null, 2)}</td>
                                <td>{o.foreign_error}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
            <DevModal
                show={changeEmail.show}
                onHide={closeModal}
                header={t("Сменить почту для чеков")}
                body={
                    <>
                        <FormFieldGroup label="UserId" required={true}>
                            <DevForm.TextInput
                                name="user_id"
                                required={true}
                                value={changeEmail.user_id}
                                onChange={(ev) => setChangeEmail((prev) => ({ ...prev, user_id: ev.target.value }))}
                            />
                        </FormFieldGroup>
                        <FormFieldGroup label="Email" required={true}>
                            <DevForm.TextInput
                                name="email"
                                required={true}
                                value={changeEmail.email}
                                onChange={(ev) => setChangeEmail((prev) => ({ ...prev, email: ev.target.value }))}
                            />
                        </FormFieldGroup>
                    </>
                }
                footer={
                    <DevForm.Button
                        variant="primary"
                        name="ban"
                        onClick={doChangeEmail}
                        disabled={!changeEmail.user_id || !changeEmail.email}
                    >
                        {t("Применить")}
                    </DevForm.Button>
                }
            />
        </ListingCard>
    );
}
